/** Common types shared across the three path adapters. */

export type PathId = "A" | "B" | "C";

export interface Message {
  id: string;
  role: "user" | "bot" | "tool";
  content: string;
  ts: number;
  toolName?: string;
}

export interface Metric {
  latencyMs?: number;
  toolCalls?: number;
  fallbacks?: number;
  /** Optional running estimate, in USD. */
  estCostUsd?: number;
}

/** Each path adapter implements this interface. */
export interface PathAdapter {
  /** Open the connection / start the mic. Returns once ready. */
  start(handlers: AdapterHandlers): Promise<void>;
  /** Send a user message. Path A uses this for text; B/C ignore it (audio-only). */
  sendText(text: string): Promise<void>;
  /** Close everything. Safe to call multiple times. */
  stop(): Promise<void>;
}

export interface AdapterHandlers {
  onMessage: (msg: Message) => void;
  onMetric: (metric: Metric) => void;
  onStatus: (status: string) => void;
  onError: (err: Error) => void;
}

export interface PathDescriptor {
  id: PathId;
  name: string;
  tagline: string;
  /** Optional dial-in number once Phase 6 ships. */
  phone?: string;
}

export const PATHS: PathDescriptor[] = [
  {
    id: "A",
    name: "Assisted NLU",
    tagline: "Amazon Lex V2 + Polly Joanna · yesterday's IVR",
  },
  {
    id: "B",
    name: "Cascaded LLM",
    tagline: "Pipecat: Deepgram + Claude Sonnet 4.6 + Cartesia · today's best-of-breed",
  },
  {
    id: "C",
    name: "Speech-to-Speech",
    tagline: "Amazon Nova 2 Sonic · tomorrow, AWS-native",
  },
];
